var _g, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDotsMenu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeWidth: 1.5,
    stroke: "currentColor",
    fill: "none",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.5 12v0c0 .276142-.223858.5-.5.5 -.276142 0-.5-.223858-.5-.5 0-.276142.223858-.5.5-.5h-2.18557e-08c.276142-1.20706e-08.5.223858.5.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 12v0c0 .276142-.223858.5-.5.5 -.276142 0-.5-.223858-.5-.5 0-.276142.223858-.5.5-.5h-2.18557e-08c.276142-1.20706e-08.5.223858.5.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 12v0c0 .276142-.223858.5-.5.5 -.276142 0-.5-.223858-.5-.5 0-.276142.223858-.5.5-.5h-2.18557e-08c.276142-1.20706e-08.5.223858.5.5"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M24 0v24h-24v-24Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotsMenu);
var MemoForwardRef = /*#__PURE__*/React.memo(ForwardRef);
export default __webpack_public_path__ + "static/media/dots-menu.ab480db38f51b0908d07b85444232b5c.svg";
export { MemoForwardRef as ReactComponent };